<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 10,
      height: 10,
      color: 'currentColor',
      viewBoxValue: `0 0 10 10`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M5.46875 2.96875L7.03125 4.53125M1.09375 7.03125V8.90625H2.96875L8.90625 2.96875L7.03125 1.09375L1.09375 7.03125Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
